<template>
  <b-modal
    v-model="isOpen"
    title="Linking a new Service"
    :width="500"
    @close="closeModal()"
  >
    <div class="service_replace_modal p-4">
      <h1 class="is-relative is-inline" style="width: fit-content">
        {{ title }}
        <b-tag
          type="is-info"
          class="px-2"
          style="
            position: absolute;
            top: -0.75rem;
            right: -2.5rem;
            height: fit-content;
          "
        >
          <p>BETA</p>
        </b-tag>
      </h1>
      <p class="has-text-left mb-2">Service Code:</p>
      <p v-if="currentServicesImporting.length > 0" class="has-text-left mb-2">
        <b-icon
          size="is-small"
          custom-size="mdi-18px"
          icon="alert"
          class="mx-2"
          style="color: #ff9316"
        ></b-icon>
        <strong>Services currently importing: </strong>
        {{ currentServicesImporting }}
      </p>
      <b-input
        :value="serviceCode"
        :readonly="service"
        placeholder="Service CODE to import"
        style="font-size: 0.8rem"
        @input="($event) => (serviceCode = `${$event}`.toLocaleUpperCase())"
      />
      <p class="has-text-left my-2">Sales Manual Code to import it.</p>
      <div class="mb-4">
        <BaseSelect
          v-model="salesManualCode"
          class="sales-manual-input mb-4"
          size="large"
          :list="availableSalesManuals"
          option-value="code"
          option-text="sales_manual_name"
          placeholder="Select sales manual"
        />
        <span class="is-flex is-align-items-center mt-1">
          <b-icon
            size="is-small"
            custom-size="mdi-18px"
            icon="clock"
            class="mx-2"
          ></b-icon>
          The estimated time to import a service is around 5 minutes
        </span>
      </div>
      <div class="is-flex is-justify-content-end">
        <BaseButton
          :disabled="salesManualCode.length === 0"
          action="principal"
          @click="onContinueClick"
        >
          <p slot="text">Continue</p>
        </BaseButton>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import BaseSelect from "@/components/base-ui/BaseSelect.vue";
import { format } from "date-fns";
import { DATE_FORMAT_YYYY_MM_DD } from "@/constants";
import BaseButton from "@/components/base-ui/BaseButton.vue";

export default {
  name: "LinkNewServiceModal",
  components: { BaseButton, BaseSelect },
  props: {
    isModalOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Linking Service",
    },
    service: {
      type: Object,
      default: () => {},
    },
    closeModal: {
      type: Function,
      default: () => {},
    },
    onContinue: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isOpen: this.isModalOpen,
      serviceCode: "",
      salesManualCode: "",
    };
  },
  computed: {
    ...mapGetters({
      itinerary: "itinerary/getItinerary",
      clientContracts: "client/getClientContracts",
      sales_manuals: "sales_manual/list",
    }),
    currentServicesImporting() {
      const servicesImporting =
        this.itinerary?.queue?.importing?.services || [];
      const uniqueServicesImporting = [...new Set(servicesImporting)];
      return uniqueServicesImporting?.join(",") || "";
    },
    selectedContract() {
      return (
        this.clientContracts.find(
          (contract) => contract.id === this.itinerary?.data?.contract_id
        ) || null
      );
    },
    selectedContractSalesManuals() {
      return this.selectedContract?.sales_manual_contract?.data || [];
    },
    availableSalesManuals() {
      return this.sales_manuals
        .filter((sm) => {
          const now = format(new Date(), DATE_FORMAT_YYYY_MM_DD);

          if (sm.end_date < now) return false;

          return this.selectedContractSalesManuals.find(
            (csm) => csm.code === sm.code
          );
        })
        .map((sm) => {
          return {
            ...sm,
            sales_manual_name: `${sm.code} (${sm.sales_manual_name})`,
          };
        });
    },
  },
  watch: {
    isModalOpen(newValue) {
      this.isOpen = newValue;
    },
    service(newValue) {
      if (newValue) {
        this.serviceCode = newValue.code;
      } else {
        this.serviceCode = "";
      }
    },
  },
  methods: {
    onContinueClick() {
      this.onContinue(this.serviceCode, [this.salesManualCode]);
      this.closeModal();
      this.salesManualCode = "";
    },
  },
};
</script>
<style scoped>
.service_replace_modal {
  width: 100%;
}
.service_replace_modal h1 {
  font-size: 1.2rem;
  font-weight: 700;
  text-align: left;
  padding-top: 0.25rem;
  padding-bottom: 0.8rem;
  color: #000;
}
.service_replace_modal p,
.service_replace_modal span,
.service_replace_modal input {
  font-size: 0.8rem;
}
.service_replace_modal .input:focus {
  color: #363636 !important;
  border: none;
  box-shadow: none;
}
</style>

<style>
.sales-manual-input .ui.search.dropdown > .text {
  max-width: 90% !important;
}
</style>
